import { render, staticRenderFns } from "./PermissionDescription.vue?vue&type=template&id=2d64f649&scoped=true"
import script from "./PermissionDescription.vue?vue&type=script&lang=js"
export * from "./PermissionDescription.vue?vue&type=script&lang=js"
import style0 from "./PermissionDescription.vue?vue&type=style&index=0&id=2d64f649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64f649",
  null
  
)

export default component.exports